<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/text';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '../package.json';

```jsx import
import {Heading, Keyboard, Text} from '@react-spectrum/text';
```

---
category: Content
---

# Keyboard

<p>{docs.exports.Keyboard.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Keyboard']} />

## Example

```tsx example
<Keyboard>⌘V</Keyboard>
```

## Content

Keyboard is used to format text indicating that is a keyboard
command. Based on the component it is used within, it gets Spectrum styling
and may have a preassigned slot for positioning. By virtue of its name, the
Keyboard component provides semantic meaning in the context they are placed.
An example of its usage in [Menu](MenuTrigger.html#complex-menu-items).
It is important to note that the Keyboard component accepts any renderable
node, not just strings.

See [the MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/kbd) for more information.

## Props

<PropTable component={docs.exports.Keyboard} links={docs.links} />
